<h2 mat-dialog-title>Copy from week</h2>
<mat-dialog-content>
  <form [formGroup]="subscriptionForm" (ngSubmit)="onSubmit()">

    <div style="display: flex; flex-direction: row; gap: 10px;">
      <div class="form-field" style="flex: 1;">
        <label for="type">Week</label>
        <mat-select formControlName="week" id="week">
          <mat-option *ngFor="let week of weeks" [value]="week">
            {{ week }}
          </mat-option>
        </mat-select>
      </div>

      <div class="form-field" style="flex: 1;">
        <label for="announcement">Year</label>
        <mat-select formControlName="year" id="year">
          <mat-option *ngFor="let year of years" [value]="year">
            {{ year }}
          </mat-option>
        </mat-select>
      </div>
    </div>



    <!-- Conditionally show fields based on the type -->
    <!-- If type is "kampanje", show only one droplist -->
    <div>
      <div class="form-field">
        <label for="type">Copy</label>
        <mat-select id="type" formControlName="type">
          <mat-option value="amountsAndProducts" selected>
            Complete menu
          </mat-option>
          <mat-option value="oneToManyDays">
            Amount from one day to many
          </mat-option>
          <!-- <mat-option value="dayAmount">
            Only day amount
          </mat-option> -->
          <mat-option value="amounts">
            Only amounts
          </mat-option>
          <mat-option value="products">
            Only products
          </mat-option>
        </mat-select>

      </div>
    </div>
    <div class="form-field" *ngIf="getType() === 'dayAmount'">
      <label for="daysFrom">Copy form days</label>
      <section id="daysFrom" class="example-section">
        <mat-checkbox class="example-margin" formControlName="fromMonday">M</mat-checkbox>
        <mat-checkbox class="example-margin" formControlName="fromTuesday">T</mat-checkbox>
        <mat-checkbox class="example-margin" formControlName="fromWednsday">W</mat-checkbox>
        <mat-checkbox class="example-margin" formControlName="fromTursday">T</mat-checkbox>
        <mat-checkbox class="example-margin" formControlName="fromFriday">F</mat-checkbox>
      </section>

    </div>
    <div class="form-field" *ngIf="getType() === 'oneToManyDays'">
      <label for="oneToManyDays">Copy form days</label>
      <mat-radio-group id="oneToManyDays" class="example-section" formControlName="oneToManyDays">
        <mat-radio-button class="example-margin" [value]="0">M</mat-radio-button>
        <mat-radio-button class="example-margin" [value]="1">T</mat-radio-button>
        <mat-radio-button class="example-margin" [value]="2">W</mat-radio-button>
        <mat-radio-button class="example-margin" [value]="3">T</mat-radio-button>
        <mat-radio-button class="example-margin" [value]="4">F</mat-radio-button>
      </mat-radio-group>

    </div>
    <div class="form-field" *ngIf="getType() === 'dayAmount' || getType() === 'oneToManyDays'">
      <label for="daysTo">Copy to days</label>
      <section id="daysTo" class="example-section">
        <mat-checkbox class="example-margin" formControlName="toMonday">M</mat-checkbox>
        <mat-checkbox class="example-margin" formControlName="toTuesday">T</mat-checkbox>
        <mat-checkbox class="example-margin" formControlName="toWednsday">W</mat-checkbox>
        <mat-checkbox class="example-margin" formControlName="toTursday">T</mat-checkbox>
        <mat-checkbox class="example-margin" formControlName="toFriday">F</mat-checkbox>
      </section>

    </div>

  </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="dialogRef.close()">Cancel</button>
  <button mat-raised-button color="primary" [disabled]="!subscriptionForm.valid" (click)="onSubmit()">
    {{ isEditMode ? 'Update' : 'Create' }}
  </button>
</mat-dialog-actions>